import React, { useEffect, useState } from "react";
import Modal from "components/Models/index";
import folderIcon from "assets/images/fileImage/folderIcon.svg";
import addIcon from "assets/images/fileImage/addIcon.svg";
import Input from "components/Input/index";
import Button from "components/Button/index";
import useScreenMobile from "hooks/useScreen";
import Drawer from "components/Drawer/index";
import useTheme from "hooks/observer";
import RenameFile from "components/RenameFile/index";
import { Item, Folder as IzFolder, File as IzFile } from "@induz/sdk";
import Breadcrumb from "containers/Homepage/Ysafe/table/BreadCrum/index";
import { useToast } from "components/Toaster/index";
import MoveCopyOptions from "containers/Homepage/Ysafe/MoveAndCopyOptions/index";
import { Task } from "@induz/sdk";
import "./moveFile.scss";

const folderName = [];

const MoveFileContent = ({
  copied,
  handleCancel,
  currentPath,
  fetchData,
  setCurrentPath,
  UUIDArrays,
  selectedFolder,
  checkedRows,
  taskManager,
  setTaskMonitorVisible,
  rowData,
  isProcessing,
  setIsProcessing,
  clearSelections,
  isOrganisationUser,
  backendOperations
}) => {
  const theme = useTheme();
  const showToast = useToast();

  const [openModal, setOpenModal] = useState(false);
  const [foldername, setFolderName] = useState("");
  const [folders, setFolders] = useState([...folderName]);
  const [currPath, setCurrPath] = useState([]);
  const [dupCurrentPath, setdupCurrentPath] = useState([]);
  const [selected, setSelected] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredFolders, setFilteredFolders] = useState([]);
  const [showConflictModal, setShowConflictModal] = useState(false);
  const [conflictingItems, setConflictingItems] = useState([]);
  const [pendingActions, setPendingActions] = useState([]);
  const [currentConflictIndex, setCurrentConflictIndex] = useState(0);
  // Root ("/") and any browsed folder are valid destinations.
  // Keep move/paste enabled so users can move items back to root.
  const canPasteToCurrentLocation = true;

  const closeMoveCopyDialog = () => {
    if (setIsProcessing) setIsProcessing(false);
    setTaskMonitorVisible(false);
    if (clearSelections) clearSelections();
    handleCancel();
  };

  useEffect(() => {
    getData();
  }, [currPath]);

  const getData = async () => {
    const toPath = (arr) => (arr?.length ? `/${arr.join("/")}` : "/");
    const normalize = (path) => path.replace(/\/+/g, "/");

    const formattedPath = toPath(currPath);

    try {
      const folderInstance = new IzFolder();

      const folder =
        formattedPath === "/"
          ? folderInstance.getRoot()
          : folderInstance.folderWithName(formattedPath);

      const list = await folder.getFolderChildrenNames(2);

      let foldersOnly = list.map((name) => ({
        name,
        type: "folder"
      }));

      const selectedSourcePaths = [];

      if (checkedRows) {
        for (const key of Object.keys(checkedRows)) {
          const fullPath = normalize(`${toPath(currentPath)}/${key}`);
          selectedSourcePaths.push(fullPath);
        }
      } else if (selectedFolder) {
        const fullPath = normalize(
          `${toPath(currentPath)}/${selectedFolder.name}`
        );
        selectedSourcePaths.push(fullPath);
      }

      // ✅ Filter invalid destinations
      foldersOnly = foldersOnly.filter((folderItem) => {
        const destinationPath = normalize(
          `${formattedPath}/${folderItem.name}`
        );

        // ❗ core rule: destination must NOT be inside source
        const isInvalid = selectedSourcePaths.some((sourcePath) => {
          return (
            destinationPath === sourcePath || // same folder
            destinationPath.startsWith(sourcePath + "/") // inside source
          );
        });

        return !isInvalid;
      });

      setFolders(foldersOnly);
    } catch (error) {
      console.error("Failed to list folders:", error);
    }
  };
  const saveHandler = async () => {
    //   if(currPath[1]==="self" && currPath[0]==="shared"){
    //   const newPath = [...currPath];
    //   newPath.splice(1, 1);
    //   currPath=newPath;
    // }
    // console.log("Curpath",currPath);
    const formattedPath =
      currPath?.length === 0 ? "/" : `/${currPath.join("/")}`;
    try {
      // console.log("Move file");
      const temp = new IzFolder();
      const root = temp.getRoot();
      await root.createFolder(formattedPath, foldername);
      showToast("Folder Created Successfully", "success");
      getData(currentPath);
      setOpenModal(false);
      setFolderName("");
    } catch (error) {
      console.error("Failed to create folder:", error);
      setFolderName("");
      setOpenModal(false);
      showToast("Failed to create Folder", "error");
    }
  };

  const cancelHandler = () => {
    setOpenModal(false);
    setFolderName("");
  };

  const searchHandler = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    const q = searchQuery.trim().toLowerCase();
    setFilteredFolders(
      q
        ? folders.filter((item) => item.name.toLowerCase().includes(q))
        : folders
    );
  }, [folders, searchQuery]);

  const handleFolderClick = (folderName) => {
    setCurrPath((prev) => [...prev, folderName]);
  };

  const copyIzFile = async (item, destinationPath, newName) => {
    const originalName = item.getName();

    const dotIndex = originalName.lastIndexOf(".");
    const extension = dotIndex !== -1 ? originalName.slice(dotIndex) : "";
    const finalName = newName.includes(".")
      ? newName
      : `${newName}${extension}`;
    await item.copy(destinationPath, finalName);
  };

  const copyIzFolder = async (item, destinationPath, newName, task) => {
    if (task) {
      await item.copy(destinationPath, newName, (progress) => {
        if (task.total_size === 1) {
          task.progress = Math.min(
            (progress.current / progress.total) * 100,
            99
          );
        }
      });
    } else {
      await item.copy(destinationPath, newName);
    }
  };

  const moveCopyHandler = async (
    source,
    destinationPath,
    newName,
    originalName,
    dupCurrentPath2,
    task
  ) => {
    try {
      // let du
      // console.log("Source",source);
      let dupCurrentPath = currentPath;
      // console.log("Current path",currentPath);
      if (dupCurrentPath[0] === "shared" && dupCurrentPath.length >= 2) {
        const newPath = [...dupCurrentPath];
        newPath.splice(1, 1);
        dupCurrentPath = newPath;
      }
      const item = await Item.getItem(source, false);
      // console.log("Item in copy",item);
      // console.log("Dup current path",dupCurrentPath);
      let finalName = newName;
      // console.log(finalName);
      if (item instanceof IzFile) {
        const dotIndex = originalName.lastIndexOf(".");
        const extension = dotIndex !== -1 ? originalName.slice(dotIndex) : "";
        finalName = newName.includes(".") ? newName : `${newName}${extension}`;
      }
      if (copied) {
        if (item instanceof IzFile) {
          if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "shared") {
            item.setFileName(item.getFileUuId());
          }
          await copyIzFile(item, destinationPath, finalName);
        } else if (item instanceof IzFolder) {
          if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "shared") {
            // const name=item.get_path();
            item.setFolderName(item.getUuId());
          }
          await copyIzFolder(item, destinationPath, finalName, task);
        }
      } else {
        await item.move(destinationPath, finalName);
      }
    } catch (error) {
      console.error("Error in moveCopyHandler:", error);
      throw error; // Re-throw to let caller handle if needed
    }
  };

  const moveHandler = async () => {
    let task = null;
    try {
      if (!canPasteToCurrentLocation) {
        showToast("Create a destination folder before pasting", "error");
        return;
      }
      let dupCurrentPath = currentPath;
      if (dupCurrentPath[0] === "shared" && dupCurrentPath.length >= 2) {
        const newPath = [...dupCurrentPath];
        newPath.splice(1, 1);
        dupCurrentPath = newPath;
      }

      const sourcePath =
        dupCurrentPath.length > 0 ? "/" + dupCurrentPath.join("/") : "/";

      const destinationPath =
        currPath.length > 0 ? "/" + currPath.join("/") : "/";

      // If the destination is the same folder, treat as a failed move/copy (no-op).
      // This prevents "success" toasts for operations that did nothing (e.g. moving to root while already in root).
      const isSameLocation = sourcePath === destinationPath;
      const conflicts = [];
      const actions = [];
      if (checkedRows) {
        if (setIsProcessing) setIsProcessing(true);
        setTaskMonitorVisible(true);
        const keys = Object.keys(checkedRows);
        const task = new Task(
          keys.length,
          copied
            ? `Copying ${keys?.length || 0} item(s)`
            : `Moving ${keys?.length || 0} item(s)`,
          "➡️"
        );
        taskManager.addRunningTask(task);
        let isCancelled = false;
        let failedNoop = 0;
        for (let i = 0; i < keys.length; i++) {
          if (task.getStatus() === 3) {
            isCancelled = true;
            break;
          }
          const key = keys[i];

          if (isSameLocation) {
            failedNoop += 1;
            continue;
          }

          const fullPath = destinationPath + "/" + key;
          try {
            const exists = await Item.getItem(fullPath, false);
            if (exists) {
              conflicts.push(key);
              if (
                dupCurrentPath.length === 1 &&
                dupCurrentPath[0] === "shared"
              ) {
                actions.push({
                  source: sourcePath + "/" + checkedRows[key],
                  originalName: key
                });
              } else
                actions.push({
                  source: sourcePath + "/" + key,
                  originalName: key
                });
            } else {
              if (
                dupCurrentPath.length === 1 &&
                dupCurrentPath[0] === "shared"
              ) {
                await moveCopyHandler(
                  sourcePath + "/" + checkedRows[key],
                  destinationPath,
                  key,
                  key,
                  dupCurrentPath,
                  task
                );
              } else
                await moveCopyHandler(
                  sourcePath + "/" + key,
                  destinationPath,
                  key,
                  key,
                  dupCurrentPath,
                  task
                );
              task.current_size += 1;
              task.progress = (100 * task.current_size) / task.total_size;
            }
          } catch (error) {
            try {
              if (
                dupCurrentPath.length === 1 &&
                dupCurrentPath[0] === "shared"
              ) {
                await moveCopyHandler(
                  sourcePath + "/" + checkedRows[key],
                  destinationPath,
                  key,
                  key,
                  dupCurrentPath,
                  task
                );
              } else
                await moveCopyHandler(
                  sourcePath + "/" + key,
                  destinationPath,
                  key,
                  key,
                  dupCurrentPath,
                  task
                );
              task.current_size += 1;
              task.progress = (100 * task.current_size) / task.total_size;
            } catch (error) {
              if (task && keys.length > 1) {
                const failed = keys.length - task.current_size;
                task.name = copied
                  ? `Copying ${task.current_size} item(s), ${failed} failed`
                  : `Moving ${task.current_size} item(s), ${failed} failed`;
              }
              const itemTypeLabel = keys.length > 1 ? "Files" : "Item";
              const actionLabel = copied ? "copied" : "moved";
              showToast(`${itemTypeLabel} cant be ${actionLabel}`, "error");
              taskManager.addCompletedTask(task, 2);
              closeMoveCopyDialog();
              return;
            }
          }
        }
        if (isCancelled) {
          task.name = copied
            ? `Cancelled — ${task.current_size} of ${keys.length} item(s) copied`
            : `Cancelled — ${task.current_size} of ${keys.length} item(s) moved`;
          taskManager.addCompletedTask(task, 3);
          showToast(copied ? "Copy cancelled" : "Move cancelled", "success");
        } else {
          if (failedNoop > 0) {
            // If everything was a no-op, mark the whole operation as failed.
            const ok = task.current_size;
            const totalFailed = keys.length - ok;
            task.name = copied
              ? `Copying ${ok} item(s), ${totalFailed} failed`
              : `Moving ${ok} item(s), ${totalFailed} failed`;
            taskManager.addCompletedTask(task, ok > 0 ? 2 : 2);
            showToast(
              copied
                ? "Copy failed: destination is the same location"
                : "Move failed: destination is the same location",
              "error"
            );
            closeMoveCopyDialog();
            return;
          }
          if (task && keys.length > 1) {
            const failed = keys.length - task.current_size;
            const suffix = failed > 0 ? `, ${failed} failed` : "";
            task.name = copied
              ? `Copying ${task.current_size} item(s)${suffix}`
              : `Moving ${task.current_size} item(s)${suffix}`;
          }
          taskManager.addCompletedTask(task, 1);
          showToast(
            copied ? "Files copied successfully" : "Files moved successfully",
            "success"
          );
        }
      } else if (selectedFolder || rowData) {
        if (setIsProcessing) setIsProcessing(true);
        setTaskMonitorVisible(true);
        const itemToUse = rowData || selectedFolder;
        const itemType = itemToUse?.type === "folder" ? "folder" : "file";
        task = new Task(
          1,
          copied ? `Copying 1 ${itemType}` : `Moving 1 ${itemType}`,
          "➡️"
        );
        taskManager.addRunningTask(task);
        if (isSameLocation) {
          taskManager.addCompletedTask(task, 2);
          const label = itemToUse?.type === "folder" ? "Folder" : "File";
          showToast(
            copied
              ? `${label} copy failed: destination is the same location`
              : `${label} move failed: destination is the same location`,
            "error"
          );
          closeMoveCopyDialog();
          return;
        }
        const itemName = itemToUse?.name;
        const fullPath = destinationPath + "/" + itemName;
        try {
          const exists = await Item.getItem(fullPath, false);
          if (exists) {
            conflicts.push(itemName);
            if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "shared") {
              actions.push({
                source: sourcePath + "/" + itemToUse.uuids,
                originalName: itemName
              });
            } else
              actions.push({
                source: sourcePath + "/" + itemName,
                originalName: itemName
              });
            task.current_size = 1;
            task.progress = 100;
            taskManager.addCompletedTask(task, 1);
          } else {
            if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "shared") {
              await moveCopyHandler(
                sourcePath + "/" + itemToUse.uuids,
                destinationPath,
                itemName,
                itemName,
                dupCurrentPath,
                task
              );
            } else
              await moveCopyHandler(
                sourcePath + "/" + itemName,
                destinationPath,
                itemName,
                itemName,
                dupCurrentPath,
                task
              );
            task.current_size = 1;
            task.progress = 100;
            taskManager.addCompletedTask(task, 1);
            const itemToUse = rowData || selectedFolder;
            const itemType = itemToUse?.type === "folder" ? "Folder" : "File";
            showToast(
              copied
                ? `${itemType} copied successfully`
                : `${itemType} moved successfully`,
              "success"
            );
          }
        } catch (error) {
          try {
            // console.log("item to user",itemToUse);
            const itemToUse = rowData || selectedFolder;
            if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "shared") {
              await moveCopyHandler(
                sourcePath + "/" + itemToUse.uuids,
                destinationPath,
                itemName,
                itemName,
                dupCurrentPath,
                task
              );
            } else
              await moveCopyHandler(
                sourcePath + "/" + itemName,
                destinationPath,
                itemName,
                itemName,
                dupCurrentPath,
                task
              );
            task.current_size = 1;
            task.progress = 100;
            taskManager.addCompletedTask(task, 1);
            const itemType = itemToUse?.type === "folder" ? "Folder" : "File";
            showToast(
              copied
                ? `${itemType} copied successfully`
                : `${itemType} moved successfully`,
              "success"
            );
          } catch (innerError) {
            taskManager.addCompletedTask(task, 2);
            throw innerError;
          }
        }
      }

      if (conflicts.length > 0) {
        // Keep the modal usable when conflicts occur.
        // If we stay in "processing" mode, the underlying modal can remain hidden and appear "stuck".
        if (setIsProcessing) setIsProcessing(false);
        setConflictingItems(conflicts);
        setPendingActions(actions);
        setCurrentConflictIndex(0);
        setShowConflictModal(true);
      } else {
        fetchData(currentPath);
        closeMoveCopyDialog();
      }
    } catch (error) {
      console.error("Error in moveHandler:", error);
      if (task) {
        taskManager.addCompletedTask(task, 2);
      }
      const itemToUse = rowData || selectedFolder;
      const itemType = itemToUse?.type === "folder" ? "Folder" : "File";
      const actionLabel = copied ? "copied" : "moved";
      showToast(`${itemType} cant be ${actionLabel}`, "error");
      closeMoveCopyDialog();
    }
  };

  const handleRename = async (newName) => {
    // Changed: Skip if no newName, proceed with rename if provided
    if (newName && pendingActions[currentConflictIndex]) {
      try {
        await moveCopyHandler(
          pendingActions[currentConflictIndex].source,
          currPath.length > 0 ? "/" + currPath.join("/") : "/",
          newName,
          pendingActions[currentConflictIndex].originalName
        );
      } catch (error) {
        showToast("Failed to rename and move/copy item", "error");
      }
    }

    // Changed: Advance to next conflict or finalize
    const nextIndex = currentConflictIndex + 1;
    if (nextIndex < conflictingItems.length) {
      setCurrentConflictIndex(nextIndex);
    } else {
      setShowConflictModal(false);
      setConflictingItems([]);
      setPendingActions([]);
      fetchData(currentPath);
      closeMoveCopyDialog();
    }
  };

  const handleModalClose = () => {
    // Changed: Skip current conflict and move to next or finalize
    const nextIndex = currentConflictIndex + 1;
    if (nextIndex < conflictingItems.length) {
      setCurrentConflictIndex(nextIndex);
    } else {
      setShowConflictModal(false);
      setConflictingItems([]);
      setPendingActions([]);
      fetchData(currentPath);
      closeMoveCopyDialog();
    }
  };

  const trimmedSearch = searchQuery.trim();
  const listForDisplay = trimmedSearch ? filteredFolders : folders;
  const showSearchNoResults =
    trimmedSearch.length > 0 && listForDisplay.length === 0;

  return (
    <>
      {!isProcessing && (
        <div
          className={`moveFileContainer ${theme === "light" ? "" : "moveFileContainerDark"}`}
        >
          <div className="folderFile">
            <div className="selectedFileName">
              <Breadcrumb
                currentPath={currPath}
                setCurrentPath={setCurrPath}
                allFiles
                dupCurrentPath={dupCurrentPath}
                setdupCurrentPath={setdupCurrentPath}
              />
            </div>
            <div className="inputBox">
              <Input
                placeholder="Search "
                searchIconBool={true}
                value={searchQuery}
                onChange={searchHandler}
                left="20px"
              />
            </div>
          </div>
          <div className="folderNamesContainer">
            {listForDisplay.length > 0 ? (
              listForDisplay.map((item, index) => (
                <div
                  className={`folderName ${selected === item.name ? "selected" : ""}`}
                  key={index}
                  onClick={() => {
                    setSelected(item.name);
                    handleFolderClick(item.name);
                  }}
                >
                  <img src={folderIcon} alt="Folder" />
                  <p>{item?.name}</p>
                </div>
              ))
            ) : showSearchNoResults ? (
              <div className="moveFileSearchEmpty" role="status">
                No matching folders
              </div>
            ) : null}
          </div>
          <div className="MoveFileFooter">
            <div
              className="footer"
              onClick={() => setOpenModal(true)}
              style={{ cursor: "pointer" }}
            >
              <img src={addIcon} alt="Add Folder" />
              <p>Create New Folder</p>
            </div>
            <Button
              title={copied ? "Paste" : "Move"}
              type="violet"
              width="32%"
              onClick={moveHandler}
              disabled={!canPasteToCurrentLocation}
            />
          </div>
        </div>
      )}

      {openModal && (
        <RenameFile
          submitBtnText="Create"
          label="Create Folder"
          placeholder="Folder name"
          value={foldername}
          onChange={(e) => {
            const newValue = e.target.value.replace(/[^a-zA-Z0-9 _\-()]/g, "");
            setFolderName(newValue);
          }}
          handleSave={saveHandler}
          handleCancel={cancelHandler}
          heading="Create Folder"
          wrapWidth="100%"
          disabled={foldername.length === 0}
          mockClass={"ysafe"}
        />
      )}

      {showConflictModal && (
        <MoveCopyOptions
          isOpen={showConflictModal}
          onClose={handleModalClose}
          onRename={handleRename}
          fileName={conflictingItems[currentConflictIndex]}
          key={conflictingItems[currentConflictIndex]} // Changed: Add key to force re-render
        />
      )}
    </>
  );
};

const MoveFile = ({
  copied = true,
  handleCancel,
  rowData,
  selectedModal,
  currentPath,
  fetchData,
  setCurrentPath,
  selectedFolder,
  checkedRows,
  UUIDArrays,
  count,
  taskManager,
  setTaskMonitorVisible,
  clearSelections,
  isOrganisationUser,
  backendOperations
}) => {
  const isMobile = useScreenMobile({ size: 992 });
  const [isProcessing, setIsProcessing] = useState(false);

  const truncateName = (name) => {
    if (!name) return "";
    return name.length > 20 ? `${name.slice(0, 5)}...` : name;
  };

  const heading = copied
    ? selectedModal === "copy"
      ? `${count || 0} Files to Copied`
      : `Copied “${truncateName(rowData?.name)}”`
    : selectedModal === "moveTo"
      ? `Move ${count || 0} Files to`
      : `Moved “${truncateName(rowData?.name)}”`;

  const content = (
    <MoveFileContent
      checkedRows={checkedRows}
      copied={copied}
      handleCancel={handleCancel}
      currentPath={currentPath}
      fetchData={fetchData}
      UUIDArrays={UUIDArrays}
      setCurrentPath={setCurrentPath}
      selectedFolder={selectedFolder}
      taskManager={taskManager}
      setTaskMonitorVisible={setTaskMonitorVisible}
      rowData={rowData}
      isProcessing={isProcessing}
      setIsProcessing={setIsProcessing}
      clearSelections={clearSelections}
      isOrganisationUser={isOrganisationUser}
      backendOperations={backendOperations}
    />
  );

  if (isProcessing) {
    return <>{content}</>;
  }

  return isMobile ? (
    <Drawer
      showFooter={false}
      showCross={true}
      heading={heading}
      isVisible={true}
      handleCancel={handleCancel}
    >
      {content}
    </Drawer>
  ) : (
    <Modal
      showFooter={false}
      showCross={true}
      heading={heading}
      handleCancel={handleCancel}
      isVisible={true}
    >
      {content}
    </Modal>
  );
};

export default MoveFile;

// import React, { useEffect, useState } from "react";
// import Modal from "components/Models/index";
// import folderIcon from "assets/images/fileImage/folderIcon.svg";
// import addIcon from "assets/images/fileImage/addIcon.svg";
// import Input from "components/Input/index";
// import Button from "components/Button/index";
// import useScreenMobile from "hooks/useScreen";
// import Drawer from "components/Drawer/index";
// import useTheme from "hooks/observer";
// import RenameFile from "components/RenameFile/index";
// import { Item, Folder as IzFolder, File as IzFile } from "@induz/sdk";
// import Breadcrumb from "containers/Homepage/Ysafe/table/BreadCrum/index";
// import { useToast } from "components/Toaster/index";
// import MoveCopyOptions from "containers/Homepage/Ysafe/MoveAndCopyOptions/index";
// import { Task } from "@induz/sdk";
// import "./moveFile.scss";

// const folderName = [];

// const MoveFileContent = ({
//   copied,
//   handleCancel,
//   currentPath,
//   fetchData,
//   setCurrentPath,
//   UUIDArrays,
//   selectedFolder,
//   checkedRows,
//   taskManager,
//   setTaskMonitorVisible
// }) => {
//   const theme = useTheme();
//   const showToast = useToast();

//   const [openModal, setOpenModal] = useState(false);
//   const [foldername, setFolderName] = useState("");
//   const [folders, setFolders] = useState([...folderName]);
//   const [currPath, setCurrPath] = useState([]);
//   const [dupCurrentPath, setdupCurrentPath] = useState([]);
//   const [selected, setSelected] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredFolders, setFilteredFolders] = useState([]);
//   const [showConflictModal, setShowConflictModal] = useState(false);
//   const [conflictingItems, setConflictingItems] = useState([]);
//   const [pendingActions, setPendingActions] = useState([]);
//   const [currentConflictIndex, setCurrentConflictIndex] = useState(0);

//   useEffect(() => {
//     getData();
//   }, [currPath]);

//   const getData = async () => {
//     const formattedPath =
//       currPath?.length === 0 ? "/" : `/${currPath.join("/")}`;
//     try {
//       const folderInstance = new IzFolder();
//       const folder =
//         formattedPath === "/"
//           ? folderInstance.getRoot()
//           : folderInstance.folderWithName(formattedPath);
//       const list = await folder.getFolderList(2);

//       // Collect all items being moved/copied (both folders and files)
//       const selectedItemNames = [];
//       if (checkedRows) {
//         for (const key of Object.keys(checkedRows)) {
//           selectedItemNames.push(key);
//         }
//       } else if (selectedFolder) {
//         selectedItemNames.push(selectedFolder.name);
//       }

//       // Create a set of full paths for items being moved/copied
//       const sourcePathSet = new Set(
//         selectedItemNames.map((name) =>
//           (currentPath?.length > 0 ? [...currentPath, name] : [name]).join("/")
//         )
//       );

//       // Process both folders and files
//       const foldersOnly = list
//         .filter((item) => item instanceof IzFolder)
//         .map((f) => {
//           const parent = f.getParentPath() ?? "";
//           const name = f.getFolderName() ?? "";
//           const fullPathStr = (parent + "/" + name)
//             .replace(/^\/+|\/+$/g, "")
//             .replace(/\/+/g, "/");
//           const pathSegments = fullPathStr ? fullPathStr.split("/") : [];
//           return {
//             name,
//             type: "folder",
//             uuid: f.getUuId?.() ? f.getUuId() : `${pathSegments.join("/")}-${name}`,
//             pathSegments
//           };
//         })
//         .filter(
//           (item) => !sourcePathSet.has((item.pathSegments ?? []).join("/"))
//         );

//       // Add files to the list (read-only, for visibility)
//       const filesOnly = list
//         .filter((item) => item instanceof IzFile)
//         .map((f) => {
//           const name = f.getName() ?? "";
//           const parent = f.getParentPath() ?? "";
//           const fullPathStr = (parent + "/" + name)
//             .replace(/^\/+|\/+$/g, "")
//             .replace(/\/+/g, "/");
//           const pathSegments = fullPathStr ? fullPathStr.split("/") : [];
//           return {
//             name,
//             type: "file",
//             uuid: f.getFileUuId?.() ? f.getFileUuId() : `${pathSegments.join("/")}-${name}`,
//             pathSegments,
//             isReadOnly: true // Mark files as read-only
//           };
//         })
//         .filter(
//           (item) => !sourcePathSet.has((item.pathSegments ?? []).join("/"))
//         );

//       // Combine folders and files, folders first
//       const combined = [...foldersOnly, ...filesOnly];
//       setFolders(combined);
//       return combined;
//     } catch (error) {
//       console.error("Failed to list folders:", error);
//       return [];
//     }
//   };

//   const saveHandler = async () => {
//     const formattedPath =
//       currPath?.length === 0 ? "/" : `/${currPath.join("/")}`;
//     try {
//       const temp = new IzFolder();
//       const root = temp.getRoot();
//       await root.createFolder(formattedPath, foldername);
//       showToast("Folder Created Successfully", "success");

//       // Clear search to ensure the newly created folder is visible
//       setSearchQuery("");
//       setFilteredFolders([]);

//       const newList = await getData();

//       // Auto-select/enter the new folder to make it ready for paste
//       if (newList) {
//         const newFolder = newList.find(f => f.name === foldername && f.type === "folder");
//         if (newFolder) {
//           handleFolderClick(newFolder);
//         }
//       }

//       setOpenModal(false);
//       setFolderName("");
//     } catch (error) {
//       console.error("Failed to create folder:", error);
//       setOpenModal(false);
//       showToast(error.message ?? "Failed to create Folder", "error");
//     }
//   };

//   const cancelHandler = () => {
//     setOpenModal(false);
//     setFolderName("");
//   };

//   const searchHandler = (e) => {
//     setSearchQuery(e.target.value);
//     const filtered = folders.filter((item) =>
//       item.name.toLowerCase().includes(e.target.value.toLowerCase())
//     );
//     setFilteredFolders(filtered);
//   };

//   const handleFolderClick = (item) => {
//     // Only allow clicking on folders, not files
//     if (item.type !== "folder" || item.isReadOnly) {
//       return;
//     }

//     const pathSegments = item.pathSegments ?? (item.name ? [item.name] : []);
//     setCurrPath((prev) => {
//       if (
//         pathSegments.length === prev.length &&
//         pathSegments.every((seg, i) => seg === prev[i])
//       ) {
//         return prev;
//       }
//       return pathSegments;
//     });
//     setSelected(item.uuid ?? item.name ?? "");
//   };

//   const copyIzFile = async (item, destinationPath, newName) => {
//     const originalName = item.getName();
//     const dotIndex = originalName.lastIndexOf(".");
//     const extension = dotIndex !== -1 ? originalName.slice(dotIndex) : "";
//     const finalName = newName.includes(".")
//       ? newName
//       : `${newName}${extension}`;
//     return await item.copy(destinationPath, finalName);
//   };

//   const copyIzFolder = async (item, destinationPath, newName) => {
//     return await item.copy(destinationPath, newName);
//   };

//   const moveCopyHandler = async (
//     source,
//     destinationPath,
//     newName,
//     originalName,
//     dupCurrentPath2
//   ) => {
//     let dupCurrentPath = currentPath;
//     if (dupCurrentPath[0] === "shared" && dupCurrentPath.length >= 2) {
//       const newPath = [...dupCurrentPath];
//       newPath.splice(1, 1);
//       dupCurrentPath = newPath;
//     }
//     const itemResult = await Item.getItem(source, false);
//     const [item] = Array.isArray(itemResult) ? itemResult : [itemResult];
//     let finalName = newName;
//     if (item instanceof IzFile) {
//       const dotIndex = originalName.lastIndexOf(".");
//       const extension = dotIndex !== -1 ? originalName.slice(dotIndex) : "";
//       finalName = newName.includes(".") ? newName : `${newName}${extension}`;
//     }
//     if (copied) {
//       if (item instanceof IzFile) {
//         if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "shared") {
//           item.setFileName(item.getFileUuId());
//         }
//         return await copyIzFile(item, destinationPath, finalName);
//       }
//       if (item instanceof IzFolder) {
//         if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "shared") {
//           item.setFolderName(item.getUuId());
//         }
//         return await copyIzFolder(item, destinationPath, finalName);
//       }
//     }
//     return await item.move(destinationPath, finalName);
//   };

//   const moveHandler = async () => {
//     let task = null;
//     try {
//       let dupCurrentPath = currentPath;
//       if (dupCurrentPath[0] === "shared" && dupCurrentPath.length >= 2) {
//         const newPath = [...dupCurrentPath];
//         newPath.splice(1, 1);
//         dupCurrentPath = newPath;
//       }
//       const sourcePath =
//         dupCurrentPath.length > 0 ? "/" + dupCurrentPath.join("/") : "/";

//       const destinationPath =
//         currPath.length > 0 ? "/" + currPath.join("/") : "/";
//       const conflicts = [];
//       const actions = [];
//       let lastSuccessMessage = null;
//       if (checkedRows) {
//         setTaskMonitorVisible(true);
//         const keys = Object.keys(checkedRows);
//         const task = new Task(
//           keys.length,
//           copied
//             ? `Copying ${keys?.length || 0} file(s)`
//             : `Moving ${keys?.length || 0} file(s)`,
//           "➡️"
//         );
//         taskManager.addRunningTask(task);
//         for (let i = 0; i < keys.length; i++) {
//           const key = keys[i];

//           const fullPath = destinationPath + "/" + key;
//           try {
//             const exists = await Item.getItem(fullPath, false);
//             if (exists) {
//               conflicts.push(key);
//               if (
//                 dupCurrentPath.length === 1 &&
//                 dupCurrentPath[0] === "shared"
//               ) {
//                 actions.push({
//                   source: sourcePath + "/" + checkedRows[key],
//                   originalName: key
//                 });
//               } else
//                 actions.push({
//                   source: sourcePath + "/" + key,
//                   originalName: key
//                 });
//             } else {
//               if (
//                 dupCurrentPath.length === 1 &&
//                 dupCurrentPath[0] === "shared"
//               ) {
//                 lastSuccessMessage = await moveCopyHandler(
//                   sourcePath + "/" + checkedRows[key],
//                   destinationPath,
//                   key,
//                   key,
//                   dupCurrentPath
//                 );
//               } else
//                 lastSuccessMessage = await moveCopyHandler(
//                   sourcePath + "/" + key,
//                   destinationPath,
//                   key,
//                   key,
//                   dupCurrentPath
//                 );
//             }
//           } catch (error) {
//             try {
//               if (
//                 dupCurrentPath.length === 1 &&
//                 dupCurrentPath[0] === "shared"
//               ) {
//                 lastSuccessMessage = await moveCopyHandler(
//                   sourcePath + "/" + checkedRows[key],
//                   destinationPath,
//                   key,
//                   key,
//                   dupCurrentPath
//                 );
//               } else
//                 lastSuccessMessage = await moveCopyHandler(
//                   sourcePath + "/" + key,
//                   destinationPath,
//                   key,
//                   key,
//                   dupCurrentPath
//                 );
//               task.current_size += 1;
//               task.progress = (100 * task.current_size) / task.total_size;
//             } catch (err) {
//               taskManager.addCompletedTask(task, 2);
//               showToast(err.message ?? "Failed to move/copy items", "error");
//               return;
//             }
//           }
//         }
//         taskManager.addCompletedTask(task, 1);
//         showToast(
//           lastSuccessMessage ??
//             (copied ? "Files copied successfully" : "Files moved successfully"),
//           "success"
//         );
//       } else if (selectedFolder) {
//         setTaskMonitorVisible(true);
//         task = new Task(
//           1,
//           copied ? "Copying 1 folder" : "Moving 1 folder",
//           "➡️"
//         );
//         taskManager.addRunningTask(task);
//         const fullPath = destinationPath + "/" + selectedFolder.name;
//         try {
//           const exists = await Item.getItem(fullPath, false);
//           if (exists) {
//             conflicts.push(selectedFolder.name);
//             if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "shared") {
//               actions.push({
//                 source: sourcePath + "/" + selectedFolder.uuids,
//                 originalName: selectedFolder.name
//               });
//             } else
//               actions.push({
//                 source: sourcePath + "/" + selectedFolder.name,
//                 originalName: selectedFolder.name
//               });
//             task.current_size = 1;
//             task.progress = 100;
//             taskManager.addCompletedTask(task, 1);
//           } else {
//             let msg = null;
//             if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "shared") {
//               msg = await moveCopyHandler(
//                 sourcePath + "/" + selectedFolder.uuids,
//                 destinationPath,
//                 selectedFolder.name,
//                 selectedFolder.name,
//                 dupCurrentPath
//               );
//             } else
//               msg = await moveCopyHandler(
//                 sourcePath + "/" + selectedFolder.name,
//                 destinationPath,
//                 selectedFolder.name,
//                 selectedFolder.name,
//                 dupCurrentPath
//               );
//             task.current_size = 1;
//             task.progress = 100;
//             taskManager.addCompletedTask(task, 1);
//             showToast(
//               msg ?? (copied ? "Folder copied successfully" : "Folder moved successfully"),
//               "success"
//             );
//           }
//         } catch (error) {
//           try {
//             let msg = null;
//             if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "shared") {
//               msg = await moveCopyHandler(
//                 sourcePath + "/" + selectedFolder.uuids,
//                 destinationPath,
//                 selectedFolder.name,
//                 selectedFolder.name,
//                 dupCurrentPath
//               );
//             } else
//               msg = await moveCopyHandler(
//                 sourcePath + "/" + selectedFolder.name,
//                 destinationPath,
//                 selectedFolder.name,
//                 selectedFolder.name,
//                 dupCurrentPath
//               );
//             task.current_size = 1;
//             task.progress = 100;
//             taskManager.addCompletedTask(task, 1);
//             showToast(
//               msg ?? (copied ? "Folder copied successfully" : "Folder moved successfully"),
//               "success"
//             );
//           } catch (innerError) {
//             taskManager.addCompletedTask(task, 2);
//             showToast(innerError.message ?? "Failed to move/copy folder", "error");
//             throw innerError;
//           }
//         }
//       }

//       if (conflicts.length > 0) {
//         setConflictingItems(conflicts);
//         setPendingActions(actions);
//         setCurrentConflictIndex(0);
//         setShowConflictModal(true);
//       } else {
//         fetchData(currentPath);
//         handleCancel();
//       }
//     } catch (error) {
//       console.error("Error in moveHandler:", error);
//       if (task) {
//         taskManager.addCompletedTask(task, 2);
//       }
//       showToast(error.message ?? "Failed to move/copy items", "error");
//       setTaskMonitorVisible(false);
//     }
//   };

//   const handleRename = async (newName) => {
//     if (newName && pendingActions[currentConflictIndex]) {
//       try {
//         const msg = await moveCopyHandler(
//           pendingActions[currentConflictIndex].source,
//           currPath.length > 0 ? "/" + currPath.join("/") : "/",
//           newName,
//           pendingActions[currentConflictIndex].originalName
//         );
//         if (msg) showToast(msg, "success");
//       } catch (error) {
//         showToast(error.message ?? "Failed to rename and move/copy item", "error");
//       }
//     }

//     // Advance to next conflict or finalize
//     const nextIndex = currentConflictIndex + 1;
//     if (nextIndex < conflictingItems.length) {
//       setCurrentConflictIndex(nextIndex);
//     } else {
//       setShowConflictModal(false);
//       setConflictingItems([]);
//       setPendingActions([]);
//       fetchData(currentPath);
//       handleCancel();
//     }
//   };

//   const handleModalClose = () => {
//     // Skip current conflict and move to next or finalize
//     const nextIndex = currentConflictIndex + 1;
//     if (nextIndex < conflictingItems.length) {
//       setCurrentConflictIndex(nextIndex);
//     } else {
//       setShowConflictModal(false);
//       setConflictingItems([]);
//       setPendingActions([]);
//       fetchData(currentPath);
//       handleCancel();
//     }
//   };

//   return (
//     <div
//       className={`moveFileContainer ${theme === "light" ? "" : "moveFileContainerDark"}`}
//     >
//       <div className="folderFile">
//         <div className="selectedFileName">
//           <Breadcrumb
//             currentPath={currPath}
//             setCurrentPath={setCurrPath}
//             allFiles
//             dupCurrentPath={dupCurrentPath}
//             setdupCurrentPath={setdupCurrentPath}
//           />
//         </div>
//         <div className="inputBox">
//           <Input
//             placeholder="Search "
//             searchIconBool={true}
//             value={searchQuery}
//             onChange={searchHandler}
//             left="20px"
//           />
//         </div>
//       </div>
//       <div className="folderNamesContainer">
//         {(searchQuery ? filteredFolders : folders).map((item) => {
//           const itemKey = item.uuid ?? item.name ?? "";
//           const pathHint =
//             item.pathSegments?.length > 0
//               ? "All Files > " + item.pathSegments.join(" > ")
//               : null;
//           const hasDuplicateNames =
//             folders.filter((f) => f.name === item.name).length > 1;
//           const isFile = item.type === "file";

//           return (
//             <div
//               className={`folderName ${selected === itemKey ? "selected" : ""} ${isFile ? "fileItem" : ""}`}
//               key={itemKey}
//               onClick={() => handleFolderClick(item)}
//               style={{
//                 cursor: isFile ? "default" : "pointer",
//                 opacity: isFile ? 0.6 : 1
//               }}
//             >
//               <img src={folderIcon} alt={isFile ? "File" : "Folder"} />
//               <div className="folderLabelWrap">
//                 <p>{item?.name}</p>
//                 {hasDuplicateNames && pathHint && (
//                   <span className="folderPathHint" title={pathHint}>
//                     {pathHint}
//                   </span>
//                 )}
//               </div>
//             </div>
//           );
//         })}
//       </div>
//       <div className="MoveFileFooter">
//         <div
//           className="footer"
//           onClick={() => setOpenModal(true)}
//           style={{ cursor: "pointer" }}
//         >
//           <img src={addIcon} alt="Add Folder" />
//           <p>Create New Folder</p>
//         </div>
//         <Button
//           title={copied ? "Paste" : "Move"}
//           type="violet"
//           width="32%"
//           onClick={moveHandler}
//         />
//       </div>

//       {openModal && (
//         <RenameFile
//           submitBtnText="Create"
//           label="Create Folder"
//           placeholder="Folder name"
//           value={foldername}
//           onChange={(e) => {
//             const newValue = e.target.value.replace(/[^a-zA-Z0-9 _\-()]/g, "");
//             setFolderName(newValue);
//           }}
//           handleSave={saveHandler}
//           handleCancel={cancelHandler}
//           heading="Create Folder"
//           wrapWidth="100%"
//           disabled={foldername.length === 0}
//           mockClass={"ysafe"}
//         />
//       )}

//       {showConflictModal && (
//         <MoveCopyOptions
//           isOpen={showConflictModal}
//           onClose={handleModalClose}
//           onRename={handleRename}
//           fileName={conflictingItems[currentConflictIndex]}
//           destinationPath={currPath.length > 0 ? "/" + currPath.join("/") : "/"}
//           key={conflictingItems[currentConflictIndex]}
//         />
//       )}
//     </div>
//   );
// };

// const MoveFile = ({
//   copied = true,
//   handleCancel,
//   rowData,
//   selectedModal,
//   currentPath,
//   fetchData,
//   setCurrentPath,
//   selectedFolder,
//   checkedRows,
//   UUIDArrays,
//   count,
//   taskManager,
//   setTaskMonitorVisible
// }) => {
//   const isMobile = useScreenMobile({ size: 992 });

//   const truncateName = (name) => {
//     if (!name) return "";
//     return name.length > 20 ? `${name.slice(0, 5)}...` : name;
//   };

//   const heading = copied
//     ? selectedModal === "copy"
//       ? `${count || 0} Files to Copied`
//       : `Copied "${truncateName(rowData?.name)}"`
//     : selectedModal === "moveTo"
//       ? `Move ${count || 0} Files to`
//       : `Moved "${truncateName(rowData?.name)}"`;

//   return isMobile ? (
//     <Drawer
//       showFooter={false}
//       showCross={true}
//       heading={heading}
//       isVisible={true}
//       handleCancel={handleCancel}
//     >
//       <MoveFileContent
//         checkedRows={checkedRows}
//         copied={copied}
//         handleCancel={handleCancel}
//         currentPath={currentPath}
//         fetchData={fetchData}
//         UUIDArrays={UUIDArrays}
//         setCurrentPath={setCurrentPath}
//         selectedFolder={selectedFolder}
//         taskManager={taskManager}
//         setTaskMonitorVisible={setTaskMonitorVisible}
//       />
//     </Drawer>
//   ) : (
//     <Modal
//       showFooter={false}
//       showCross={true}
//       heading={heading}
//       handleCancel={handleCancel}
//       isVisible={true}
//     >
//       <MoveFileContent
//         checkedRows={checkedRows}
//         copied={copied}
//         UUIDArrays={UUIDArrays}
//         handleCancel={handleCancel}
//         currentPath={currentPath}
//         fetchData={fetchData}
//         setCurrentPath={setCurrentPath}
//         selectedFolder={selectedFolder}
//         taskManager={taskManager}
//         setTaskMonitorVisible={setTaskMonitorVisible}
//       />
//     </Modal>
//   );
// };

// export default MoveFile;
